import LocalizedStrings from "react-localization";
import dayjs from "dayjs";
import "dayjs/locale/fr";
import "dayjs/locale/en";

export const getLocalizedMonths = (lang) =>
  Array.from({ length: 12 }, (_, i) =>
    dayjs().locale(lang).month(i).format("MMM"),
  );

export const dataIngestionStrings = new LocalizedStrings({
  en: {
    title: "Data ingestion",
    displayType: "Display type",
    desktop: "Desktop",
    mobile: "Mobile",
    refresh: "Refresh",

    legend: "Legend",
    finished: "Finished",
    inProgress: "In progress",
    error: "Error",

    lastImportBtn: "LAST IMPORT",
    importedFilesBtn: "IMPORTED FILES",

    lastImportSummary: "Last import summary",

    fields: {
      startExecutionDate: "Start execution date",
      endExecutionDate: "End execution date",
      fileName: "File name",
      status: "Status",
      message: "Message",
    },

    table: {
      fileName: "File name",
      displayType: "Display type",
      noOfLines: "No. of lines",
      ingestedLines: "Ingested lines",
      status: "Status",
      message: "Message",
      startDate: "Start date of ingestion",
      endDate: "End ingestion date",
    },

    errors: {
      selectDisplayTypeFirst: "Please select a Display type first.",
      notXlsx: "Please select a .xlsx file.",
      apiGeneric: "An error occurred while calling the API.",
      uploadFailed: "Upload failed",
      uploadedSuccessfully: "Uploaded successfully",
      anotherUploadInProgress:
        "Another upload is already in progress for this display type. Please wait until it finishes.",
    },

    statuses: {
      done: "Done",
      inProgress: "In Progress",
      idle: "—",
    },
  },

  fr: {
    title: "Ingestion des données",
    displayType: "Type d’affichage",
    desktop: "Desktop",
    mobile: "Mobile",
    refresh: "Rafraîchir",

    legend: "Légende",
    finished: "Terminé",
    inProgress: "En cours",
    error: "Erreur",

    lastImportBtn: "DERNIER IMPORT",
    importedFilesBtn: "FICHIERS IMPORTÉS",

    lastImportSummary: "Résumé du dernier import",

    fields: {
      startExecutionDate: "Date de début d’exécution",
      endExecutionDate: "Date de fin d’exécution",
      fileName: "Nom du fichier",
      status: "Statut",
      message: "Message",
    },

    table: {
      fileName: "Nom du fichier",
      displayType: "Type d’affichage",
      noOfLines: "Nb. de lignes",
      ingestedLines: "Lignes ingérées",
      status: "Statut",
      message: "Message",
      startDate: "Début de l’ingestion",
      endDate: "Fin de l’ingestion",
    },

    errors: {
      selectDisplayTypeFirst:
        "Veuillez d’abord sélectionner un type d’affichage.",
      notXlsx: "Veuillez sélectionner un fichier .xlsx.",
      apiGeneric: "Une erreur est survenue lors de l’appel à l’API.",
      uploadFailed: "Échec de l’upload",
      uploadedSuccessfully: "Upload réussi",
      anotherUploadInProgress:
        "Un autre upload est déjà en cours pour ce type d’affichage. Veuillez attendre qu’il se termine.",
    },

    statuses: {
      done: "Terminé",
      inProgress: "En cours",
      idle: "—",
    },
  },
});
